import React, { useEffect, useRef } from 'react';
import composeRefs from '@seznam/compose-react-refs';
import cx from 'classnames';

import { LoadingInline } from "ui/control";
import { useIsTinyScreen } from "ui/hook";
import "./Button.css";

type Props = {
    variant: string;
    size?: "sm" | "lg";
    compact?: boolean;
    borderless?: boolean;
    invisible?: boolean;
    active?: boolean;
    loading?: boolean;
    ref?: React.Ref<HTMLButtonElement>;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export function Button(
    {
        variant, size, compact = false, borderless = false, invisible = false, active = false, loading = false,
        disabled = false, className = "", type = "button", autoFocus, ref, ...props
    }: Props
) {
    const tinyScreen = useIsTinyScreen();
    const domRef = useRef<HTMLButtonElement>(null);

    useEffect(() => {
        if (autoFocus && domRef.current != null) {
            domRef.current.focus();
        }
    }, [domRef, autoFocus]);

    const klass = cx(
        "btn",
        `btn-${variant}`,
        {
            "btn-sm": size === "sm",
            "btn-lg": size === "lg",
            "border-0": borderless,
            invisible,
            active,
            "btn-loading": loading
        },
        className
    );

    return (
        <button type={type} className={klass} disabled={loading || disabled} {...props}
                ref={composeRefs(domRef, ref)}>
            {!(loading && (compact || tinyScreen)) &&
                <>{props.children}</>
            }
            {loading && <LoadingInline/>}
        </button>
    );
}
